<template>
  <div class="news-list__item" v-if="article">
    <h1 class="news-title">{{{article.Name}}}</h1>
    <time class="news-date">{{article.ItemDate}}</time>
    <p class="news-leading">{{{article.Introduction}}}</p>
    <a v-link="'/news/'+article.Id" class="simple-button">{{getResource('ReadMore')}}</a>
  </div>
  <loading v-else class="news-list__loading"></loading>
</template>


<script>
import Loading from "../../shared/Loading";
import { getResource } from "../../vuex/helpers";

export default {
  props: ["article"],
  components: { Loading },
  vuex: {
    actions: { getResource }
  }
};
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .news-list{
    position: relative;
    &__item{
      @include col(30px);
      background: $brown_light;
      color: $white;
      padding: 52px 52px 40px;
      margin: 0 0 20px;
      width: 50%;
      box-sizing: border-box;
      overflow: hidden;
      border-bottom: 30px solid #fff;
      float: left;
      margin-bottom: -99999px;
      padding-bottom: 99999px;


      a{
        position: absolute;
        bottom: 50px;
      }
    }

    &__loading{
      @include col(30px);
      background: $brown_light;
      width: 50%;
      height: 410px;
      float: left;
    }
  }

  .news-date{
    color: $green;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .news-title{
    font-size: 36px;
    line-height: 40px;
    margin: 0px 0px 40px;
    font-weight: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .news-leading{
    margin: 0 0 100px;
    line-height: 24px;
    height: 120px;
    overflow: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    *{
      background: none !important;
      color: $white !important;
      text-align: left !important;
      font-size: 16px !important;
      margin: 0px !important;
    }
  }
</style>


// WEBPACK FOOTER //
// HomeNewsItem.vue?558c242c